import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { ListGroup, ListGroupItem, Input, Label, Row, Col } from 'reactstrap';
import IconButton from '@material-ui/core/IconButton';
import { MdAttachFile } from 'react-icons/md';
import { RiDeleteBin6Line } from 'react-icons/ri';

// Redux
import { connect } from 'react-redux';

//Componentes
import CustomModal from '../../../components/modales/customModal';
import AttachCardV2 from '../../../components/cards/attachCardV2';

//Funciones
// import { handleFilesAdd, deleteFile } from '../../../utils/azureStorage/upload';
import { deleteFile, singleFileUploader } from '../../../utils/FirebaseStorage/FirebaseStorage';
import { functionsHttpsCallable } from '../../../utils/FirebaseStorage/firebase';

const actualizarAPE = functionsHttpsCallable('ape_actualizarSolicitudEmpleo');


const mapStateToProps = state => ({
    usuarioActivo: state
})

const ModalEstudioSeguridad = (props)=>{
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const [updFile, setUpdFile] = useState([]);
    
    useEffect(() => {
    }, [])

    const listadoAdjuntos =[
        {
            name:'Respesta Inspektor',
            key:'RESPUESTA_INSPEKTOR',
        },
        {
            name:'Respuesta Estudio de Seguridad',
            key:'RESPUESTA_ESTUDIO_SEGURIDAD',
        },
        {
            name: 'Respuesta Poligrafía',
            key: 'RESPUESTA_POLIGRAFIA',
        },
        {
            name: 'Autorización de Antecedentes',
            key: 'AUTORIZACION_ANTECEDENTES',
        },
        {
            name: 'Conflicto de Interés',
            key: 'CONFLICTO_INTERES',
        },
        {
            name: 'Acta de Aceptacion al Proceso',
            key: 'ACEPTACION_PROCESO',
        },
    ]

    const fileExist = (filename) => {
        const newArr = props.fileList.filter(file => file.fileName.split('.')[0] == filename)
        return { exists: newArr.length > 0, file: newArr.length > 0 ? newArr[0] : undefined }
    }


    const fileReadyToUpload = (filename) => {
        const newArr = updFile.filter(file => file.key === filename)
        return newArr.length > 0
    }

    const handleUpdate = async () => {
        let body = {
            cod_soli: props.id,
            cod_empr: userData.codigoEmpresa,
            data: {
                cmp_stat: 'EXAMEN_MEDICO'
            },

        }
        try {
            await actualizarAPE(body)
            props.updateAPE({
                estadoAPE: 'EXAMEN_MEDICO'
            })
        }
        catch (error) {
            props.toastError('Hubo un error!');
        }
        props.toggle();
        props.toastSuccess('Estado Actualizado!');
    }

    return (
        <React.Fragment>
            <CustomModal
                modal={props.modal}
                toggle={() => props.toggle()}
                buttonTitle={'Actualizar'}
                onClick={() => handleUpdate()}
                buttonLoading={false}
                title={`Actualizar estado a ${props.newState}`}
            >
                <Row>
                    {listadoAdjuntos.map((doc, index) => {
                        return (
                            <Col key={`col1_${index}`} lg='3' md='6' xs="12">
                                <AttachCardV2
                                    id={`${doc.key}`}
                                    subText={`${doc.name}`}
                                    attached={fileReadyToUpload(`${doc.key}`) || fileExist(`${doc.key}`).exists}
                                    file={fileExist(`${doc.key}`).file}
                                    apeId={props.id}
                                    fileList={props.fileList}
                                    setLoading={(e) => props.setLoading(e)}
                                    setFileList={(e) => { props.setFileList(e) }}
                                />
                            </Col>

                        )
                    })}
                </Row>
            </CustomModal>
        </React.Fragment>
    );
}

export default connect(mapStateToProps)(ModalEstudioSeguridad);